import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { OktaService } from '@engie-group/ngx-gem-spaas';
import { DataGridsHelper } from 'src/app/core/data-grids-helper';
import { FirstHydroInstructionsGridDto } from 'src/app/core/Dtos/fhc-hydro/instructions-grid-dto';
import { AlertsService } from 'src/app/core/services/alerts.service';
import { DateFormatHelperService } from 'src/app/core/services/date-format-helper.service';
import { BaseComponent } from 'src/app/features/base-component';

@Component({
  selector: 'app-fhc-instructions',
  templateUrl: './fhc-instructions.component.html',
  styleUrl: './fhc-instructions.component.scss',
  standalone: false
})
export class FhcInstructionsComponent extends BaseComponent {
  @Output() 
  public OnViewInstruction : EventEmitter<string | number> = new EventEmitter<string | number>();
  @Input("GridData")
  public set CurrentSearchData(data : FirstHydroInstructionsGridDto[])
  {
    this.DataGridHelper.GridData = data;
  }

  public DataGridHelper: DataGridsHelper<FirstHydroInstructionsGridDto> = new DataGridsHelper<FirstHydroInstructionsGridDto>();

  constructor(
      dateFormatHelper: DateFormatHelperService,
      oktaService: OktaService,
      private _router: Router,
      alertService: AlertsService) 
  {
    super(oktaService, alertService, dateFormatHelper)
  }
  
  public ViewInstruction(instructionId:number|string){
    // let id= parseInt(instructionId);
 //    let viewingRoute = this._addNewRoute+'/'+instructionId;
 //    this._router.navigate([viewingRoute]);
     this.OnViewInstruction?.next(instructionId);
   }

   public CopyToNew(instructionId: number | string) {
    let viewingRoute = `fhc-new/${instructionId}`;
    this._router.navigate([viewingRoute]);
  }
  
  public GetClass(startDate: Date | string, endDate: Date | string) {
    let sd = new Date(startDate),
      ed = (endDate ?? "") == "" ? null: new Date(endDate),
      today = new Date();
    
    if (today > sd && (ed == null || today < ed))
      return "day-instruction";

    return "";
  }
}
